import type { TranslationKeys } from './en'

export const es: TranslationKeys = {
  schoolSubtitle: 'Accede a través de la aplicación Agenda1',
  scanQrCode: 'Apunta la cámara de tu teléfono al código QR',
  or: 'o',
  downloadApp: 'Descarga la aplicación desde las tiendas oficiales',
  appStoreBadgeUrl: 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/es-es?size=250x83',
  appStoreBadgeAlt: 'Descargar en App Store',
  playStoreBadgeUrl: 'https://play.google.com/intl/es_es/badges/static/images/badges/es_badge_web_generic.png',
  playStoreBadgeAlt: 'Disponible en Google Play',
  openAppStore: 'Abrir en App Store',
  openPlayStore: 'Abrir en Google Play',
  printQrCode: 'Imprimir código QR',
  schoolCode: 'Código de la escuela',
  scanInstruction: 'Apunta la cámara de tu teléfono al código QR de arriba',
  accessUrl: 'o accede a',
  needHelp: '¿Necesitas ayuda? Contacta con soporte',
  support: 'soporte@agenda1.app',
  copyright: `© ${new Date().getFullYear()} Agenda1. Todos los derechos reservados.`,
  // Mobile 2-step flow
  step1Title: 'Descarga la App',
  step1Description: 'Si aún no la tienes, descarga Agenda1',
  step2Title: 'Abre la Escuela',
  step2Description: 'Toca para abrir la escuela en la app',
  openSchoolButton: 'Abrir Escuela en la App',
  alreadyHaveApp: '¿Ya tienes la app?'
}
